import * as walletAddress from "./walletAddress";

export default {
    ...walletAddress,
};
